module.exports = __webpack_public_path__ + "img/ring_y_0_0_0@3x.c1441b25.png";